import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { PaginationEmpty, QueryPagination } from 'domain/models/queryPagination'
import {
  Package,
  ReadPackagesQueryResponse,
  ReadVotingInfoQueryResponse,
} from 'domain/entities/package'
import { PackageState } from 'domain/models/package'
import { RootState } from 'presentation/redux/reducers'

const initialState: PackageState = {
  error: null,
  errorSelectPackage: null,
  errorDeletePackage: null,
  errorPublishPackages: null,
  errorVotingInfo: null,
  isLoading: false,
  packages: [],
  selectedPackages: [],
  pagination: PaginationEmpty,
  promotionVotingInfo: null,
}
export const packageSlice = createSlice({
  name: 'package',
  initialState,
  reducers: {
    getPackagesStart: (state: PackageState) => {
      state.isLoading = true
      state.error = null
      state.errorSelectPackage = null
    },
    getPackagesSuccess: (state: PackageState, action: PayloadAction<ReadPackagesQueryResponse>) => {
      state.isLoading = false
      state.packages = action.payload.entities as Package[]
      state.pagination = action.payload.pagination as QueryPagination
    },
    getPackagesError: (state: PackageState, action: PayloadAction<string>) => {
      state.isLoading = false
      state.error = action.payload
    },
    selectPackageStart: (state: PackageState) => {
      state.isLoading = true
      state.error = null
      state.errorSelectPackage = null
    },
    selectPackageSuccess: (state: PackageState) => {
      state.isLoading = false
    },
    selectPackageError: (state: PackageState, action: PayloadAction<string>) => {
      state.isLoading = false
      state.errorSelectPackage = action.payload
    },
    getSelectedPackagesStart: (state: PackageState) => {
      state.isLoading = true
      state.error = null
      state.errorSelectPackage = null
    },
    getSelectedPackagesSuccess: (
      state: PackageState,
      action: PayloadAction<ReadPackagesQueryResponse>,
    ) => {
      state.isLoading = false
      state.selectedPackages = action.payload.entities as Package[]
      state.pagination = action.payload.pagination as QueryPagination
    },
    getSelectedPackagesError: (state: PackageState, action: PayloadAction<string>) => {
      state.isLoading = false
      state.error = action.payload
    },
    publishSelectedPackagesStart: (state: PackageState) => {
      state.isLoading = true
      state.errorPublishPackages = null
    },
    publishSelectedPackagesSuccess: (state: PackageState) => {
      state.isLoading = false
    },
    publishSelectedPackagesError: (state: PackageState, action: PayloadAction<string>) => {
      state.isLoading = false
      state.errorPublishPackages = action.payload
    },
    deleteSelectedPackageStart: (state: PackageState) => {
      state.isLoading = true
      state.errorDeletePackage = null
    },
    deleteSelectedPackageSuccess: (state: PackageState) => {
      state.isLoading = false
    },
    deleteSelectedPackageError: (state: PackageState, action: PayloadAction<string>) => {
      state.isLoading = false
      state.errorDeletePackage = action.payload
    },
    votingInfoStart: (state: PackageState) => {
      state.isLoading = true
      state.errorVotingInfo = null
    },
    votingInfoSuccess: (
      state: PackageState,
      action: PayloadAction<ReadVotingInfoQueryResponse>,
    ) => {
      state.isLoading = false
      state.promotionVotingInfo = action.payload
    },
    votingInfoError: (state: PackageState, action: PayloadAction<string>) => {
      state.isLoading = false
      state.errorVotingInfo = action.payload
    },
    clearErrorPackage: (state: PackageState) => {
      state.errorSelectPackage = null
      state.errorDeletePackage = null
      state.errorPublishPackages = null
      state.errorVotingInfo = null
    },
  },
})
export const {
  getPackagesStart,
  getPackagesSuccess,
  getPackagesError,
  selectPackageStart,
  selectPackageSuccess,
  selectPackageError,
  getSelectedPackagesStart,
  getSelectedPackagesSuccess,
  getSelectedPackagesError,
  publishSelectedPackagesStart,
  publishSelectedPackagesSuccess,
  publishSelectedPackagesError,
  deleteSelectedPackageStart,
  deleteSelectedPackageSuccess,
  deleteSelectedPackageError,
  votingInfoStart,
  votingInfoSuccess,
  votingInfoError,
  clearErrorPackage,
} = packageSlice.actions

export const packageState = (state: RootState) => state.package
export default packageSlice.reducer
